import type { UserData } from "../model/types/userData";
import type { UserFeatures } from "../model/types/userFeatures";

function isSparkProduct(productName: string | undefined | null): boolean {
  return !!productName && productName.includes("Spark");
}

function isFlameProduct(productName: string | undefined | null): boolean {
  return !!productName && productName.includes("Flame");
}

function isLightProduct(productName: string | undefined | null): boolean {
  return !!productName && productName.includes("Light");
}

function isMultiAdvisorProduct(productName: string | undefined | null): boolean {
  return isFlameProduct(productName) || isLightProduct(productName);
}

export function getUserFeatures(userData: UserData): UserFeatures {
  const isMultiAdvisors = isMultiAdvisorProduct(userData.product?.name);
  const hasUnlimitedAdvisors = isLightProduct(userData.product?.name);
  const hasOpenAdvisorSlots = userData.assignedPersonalities.length < userData.maxAssignedPersonalities;
  const isFlameWithOpenSlots = isMultiAdvisors && !hasUnlimitedAdvisors && hasOpenAdvisorSlots;

  return {
    isMultiAdvisors,
    hasUnlimitedAdvisors,
    advisorChangesLeft: userData.maxPersonalityChanges - userData.personalityChangesThisCycle,
    hasOpenAdvisorSlots,
    isFlameWithOpenSlots,
    isProductAnnual: userData.product?.interval === "year",
  };
}
